/**
 * VAT invariant: a redevable document (>= 1 line carrying a vatRate) requires a
 * non-empty company vatId. Enforced from two sides:
 *  - #396 blocks removing the vatId once taxable documents exist (write guard on
 *    company legal settings);
 *  - #402 blocks emitting a taxable document while the vatId is empty (guard at
 *    invoice finalizing / quotation creation).
 *
 * These are pure predicates + the shared user-facing message. The actual throw
 * (NestJS `BadRequestException`) stays in the backend services — `@mytour/shared`
 * must not depend on `@nestjs/common`.
 */
/**
 * True when the company vatId is absent or only whitespace. Mirrors the legal
 * setting persistence semantics (the column is nullable and trimmed on read).
 */
export function isEmptyVatId(value) {
    return value == null || value.trim() === "";
}
/**
 * True when at least one line carries a VAT rate (vatRate != null — a 0 % rate
 * is an explicit taxable bucket, only null/undefined is franchise). Mirrors
 * `hasVatToCollect`'s "any taxable bucket" rule but operates on raw line arrays
 * available before persistence (invoice/quotation services + shiftings), where
 * the full entity isn't built yet.
 */
export function hasTaxableLine(lines) {
    return lines.some((line) => line.vatRate != null);
}
export const VAT_ID_REQUIRED_FOR_TAXABLE_LINES_MESSAGE = "Impossible de finaliser : ce document comporte des lignes soumises à TVA mais votre numéro de TVA n'est pas renseigné. Renseignez-le dans vos réglages de facturation.";
//# sourceMappingURL=vatInvariant.js.map